import axios from 'axios';
import appConfig from '@/config';
import app from '@/main';

const api = axios.create({
  baseURL: appConfig.API_BASE,
  timeout: 8000,
});

api.interceptors.request.use(
  (config) => {
    // console.log(config.data);
    if (config.data instanceof FormData) return config;
    config.data = { ...config.data, ...{ token: localStorage.getItem('token') } };
    return config;
  },
  req => Promise.reject(req),
);

// 请求返回拦截，目前需要结合各项目自身来处理...
api.interceptors.response.use(
  (res) => {
    if (!res.data) return Promise.resolve(res);
    const data = res.data;
    if (data.code === 200 ) return Promise.resolve(data.data);
    if (data.code === 201 ) return Promise.reject(data);
    app.$message.error(data.msg || '系统出错，请稍后再试');
    if (data.msg === '无效的Token') app.$router.replace('/login');
    return Promise.reject(data);
  },
  err => Promise.reject(err),
);

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js